import type { DeviceMetricModule } from '../../collection/metrics/types';
import { defaultField, fieldPresentation, measurementContext, metricPresentation, recordingKind, recordKindLabel, ultrahumanCategories } from './presentation';

export const ultrahumanMetricModule: DeviceMetricModule = {
  id: 'ultrahuman', label: 'Ultrahuman',
  categories: ultrahumanCategories,
  matches: metric => Boolean(metric.routeKey?.startsWith('ultrahuman_') || metric.dataType.startsWith('ultrahuman_')),
  defaultField, fieldPresentation, measurementContext, metricPresentation, recordingKind, recordKindLabel,
};
